module.exports = require("core-js/modules/esnext.set.intersection.js");